module.exports = __webpack_public_path__ + "img/newtaiyo11.4d2849e7.png";